import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/frameworkassure/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppShell"] */ "/workspace/frameworkassure/src/components/layout/app-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageTransition"] */ "/workspace/frameworkassure/src/components/layout/page-transition.tsx");
